import React from "react";
import { useTranslation } from "react-i18next";
import OImage from "components/reusable/OImage";

const CategoryImageModal = ({ selectedItem, setSelectedItem, closeImageModal }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="my-6 mx-auto relative max-w-sm w-[90%]">
          <div className="sm:py-4 sm:px-2 py-8 px-8 ">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
              <div className="dark:bg-LightBlue dark:text-white flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("VIEW_CATEGORY_IMAGES")}</h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => {
                    closeImageModal(false);
                    setSelectedItem({});
                  }}
                >
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="flex justify-center gap-x-4">
                <OImage src={selectedItem?.file || "/images/user.png"} className="h-[200px] object-contain w-full m-4 max-w-[300px]" />
              </div>
              <div className="dark:bg-LightBlue flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded ease-linear transition-all duration-150"
                  type="button"
                  title={t("O_BACK")}
                  onClick={() => {
                    closeImageModal(false);
                    setSelectedItem({});
                  }}
                >
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </div>
  );
};

export default CategoryImageModal;
